import { lazy } from "react";

const Reviews = lazy(() => import("./Reviews"));
const CreateReview = lazy(() => import("./create/CreateReview"));
const EditReview = lazy(() => import("./edit/EditReview"));

const reviewRoutes = [
  {
    path: "reviews",
    children: [
      // Most specific routes first
      {
        element: CreateReview,
        path: "create",
      },
      // page specific, we use full routes since pages are distinct
      {
        element: EditReview,
        path: ":reviewId/edit",
      },
      // Main reviews page with review type parameter (cyclical, new, etc)
      {
        element: Reviews,
        path: ":reviewType",
      },
      // Default reviews page
      {
        element: Reviews,
        path: "",
      },
    ],
  },
];
export default reviewRoutes;
